// Enumerations
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
// Translations
import {
  KYC_LANDING_MODAL_ACCOUNT_CHECK,
  KYC_LANDING_MODAL_BIZUM,
  KYC_LANDING_MODAL_VIDEOCALL,
} from '../translations/kyc-landing.translations';

const KYC_LANDING_MODAL_CONFIGURATION = {
  features: {
    [`${KycMethodsEnumeration.ACCOUNT_CHECK}`]: [
      {
        description: KYC_LANDING_MODAL_ACCOUNT_CHECK.feature_01,
        icon: 'icon_symbols_checkmark',
      },
      {
        description: KYC_LANDING_MODAL_ACCOUNT_CHECK.feature_02,
        icon: 'icon_documents_document',
      },
      {
        description: KYC_LANDING_MODAL_ACCOUNT_CHECK.feature_03,
        icon: 'icon_security_close',
      },
    ],
    [`${KycMethodsEnumeration.BIZUM}`]: [
      {
        description: KYC_LANDING_MODAL_BIZUM.feature_01,
        icon: 'icon_objects_bell',
      },
      {
        description: KYC_LANDING_MODAL_BIZUM.feature_02,
        icon: 'icon_symbols_checkmark',
      },
      {
        description: KYC_LANDING_MODAL_BIZUM.feature_03,
        icon: 'icon_security_close',
      },
    ],
    [`${KycMethodsEnumeration.VIDEOCALL}`]: [
      {
        description: KYC_LANDING_MODAL_VIDEOCALL.feature_01,
        icon: 'icon_objects_flashlight-on',
      },
      {
        description: KYC_LANDING_MODAL_VIDEOCALL.feature_02,
        icon: 'icon_devices_mobile',
      },
      {
        description: KYC_LANDING_MODAL_VIDEOCALL.feature_03,
        icon: 'icon_documents_document',
      },
    ],
  },
};

const KYC_LANDING_CONSENT_PROPS = {
  checked: false,
  type: KycMethodsEnumeration.VIDEOCALL,
};

export { KYC_LANDING_MODAL_CONFIGURATION, KYC_LANDING_CONSENT_PROPS };
